import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import { checkLogin } from "features/common/auth/authSlice";
import DiegoVpn from "pages/DiegoVpn";
import DigitalSignature from "pages/DigitalSignature";
import DomainBackorder from "pages/Domain/DomainBackorder";
import EmailSuite from "pages/EmailSuite";
import OtherProduct from "pages/OtherProduct";
import PageError from "pages/PageError";
import PaymentMethod from "pages/PaymentMethod";
import OrderSSL from "pages/SSL";
import Summary from "pages/Summary";
import TestingOrder from "pages/TestingOrder";
import UpgradePage from "pages/Upgrade";
import RenewPage from "pages/Renew";
import AddonPage from "pages/Addon";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import persistStore from "redux-persist/es/persistStore";
import { PersistGate } from "redux-persist/integration/react";
import App from "./App";
import { store } from "./app/store";
import "./assets/css/customize-component.css";
import "./assets/css/main.css";
import Domain from "./pages/Domain";
import Hosting from "./pages/Hosting";
import Vps from "./pages/VPS";
import Server from "./pages/Server";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";

const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <App />,
      errorElement: <PageError />,
    },
    {
      path: "testingorder",
      element: <TestingOrder />,
    },
    {
      path: "orderhosting",
      element: <Hosting />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderdomain",
      element: <Domain />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderemailsuite",
      element: <EmailSuite />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "ordersignature",
      element: <DigitalSignature />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderdomainbackorder",
      element: <DomainBackorder />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderdiegovpn",
      element: <DiegoVpn />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "ordervps",
      element: <Vps />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderserver",
      element: <Server />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "ordersummary",
      element: <Summary />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "paymentmethod",
      element: <PaymentMethod />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderproduct",
      element: <OtherProduct />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "orderssl",
      element: <OrderSSL />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "migrasihosting",
      element: <Hosting />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "upgrade",
      element: <UpgradePage />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "renew",
      element: <RenewPage />,
      errorElement: <PageError not404={true} />,
    },
    {
      path: "addon",
      element: <AddonPage />,
      errorElement: <PageError not404={true} />,
    },
  ],
  {
    basename: process.env.REACT_APP_BASE_PATH,
  }
);

const container = document.getElementById("root");
const root = createRoot(container);

let persistor = persistStore(store);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider>
            <RouterProvider router={router} />
          </ThemeProvider>
        </PersistGate>
      </Provider>
    </ErrorBoundary>
  </React.StrictMode>
);

store.dispatch(checkLogin());

// Global error handler for DOM manipulation errors
window.addEventListener('error', (event) => {
  if (event.error && event.error.message && (
    event.error.message.includes('removeChild') ||
    event.error.message.includes('appendChild') ||
    event.error.message.includes('insertBefore') ||
    event.error.message.includes('NotFoundError') ||
    event.error.message.includes('Failed to execute') ||
    event.error.message.includes('The node to be removed is not a child')
  )) {
    console.warn('DOM manipulation error caught globally:', event.error.message);
    event.preventDefault();
    return false;
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && (
    event.reason.message.includes('removeChild') ||
    event.reason.message.includes('appendChild') ||
    event.reason.message.includes('insertBefore') ||
    event.reason.message.includes('NotFoundError') ||
    event.reason.message.includes('Failed to execute') ||
    event.reason.message.includes('The node to be removed is not a child')
  )) {
    console.warn('DOM manipulation promise rejection caught globally:', event.reason.message);
    event.preventDefault();
    return false;
  }
});
